module.exports = __webpack_public_path__ + "static/media/landing-benefit-implementation.756f5367.svg";